export enum CookieType {
  CURRENT_LANGUAGE = 'feCurrentLanguage',
  AUTH_TOKEN = 'feMesHubAuthToken',
  PROCESS_STATE = 'feProcessState',
  OLD_LOANS_POP_UP = 'feOldLoansPopUp',
  GOOGLE_ANALYTICS_IDENTITY_COOKIE = '_ga',
  COOKIE_CONSENT = 'hasAcceptedCookies',
  SUCCESS_REGISTRATION_PROCESS = 'feSuccessRegistrationProcessData'
}
